// Which of the bookings on screen are CRM 2.0 (AllotmentPayment.isCrm2), for today's screens whose list
// rows have no isCrm2 column (M2-F7 pattern, M4-F1). rows = today's list rows; idKey = their booking id field.
import { useEffect, useState } from "react";
import { supabase } from "../../../supabaseClient";

export default function useCrm2Ids(rows, idKey = "allotment_payment_id") {
  const [ids, setIds] = useState(() => new Set());
  useEffect(() => {
    const list = [...new Set((rows || []).map((r) => r?.[idKey]).filter(Boolean))];
    if (!list.length) return;
    supabase
      .from("AllotmentPayment")
      .select("allotmentPaymentId")
      .in("allotmentPaymentId", list)
      .eq("isCrm2", true)
      .then(({ data, error }) => {
        if (error) return console.error("[crm2][useCrm2Ids] CRM 2.0 booking lookup failed", { error: error.message });
        if (data?.length) setIds((prev) => new Set([...prev, ...data.map((r) => r.allotmentPaymentId)]));
      });
  }, [rows, idKey]);
  return ids;
}
